import { render, staticRenderFns } from "./full-amount.vue?vue&type=template&id=178efa7f&"
import script from "./full-amount.vue?vue&type=script&lang=js&"
export * from "./full-amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports